<template>
  <div class="Lette-list" ref="listView" @scroll.passive="isReachBottom">
    <LeftListItem
      v-for="(item, index) in list"
      :key="index"
      :type="item.type"
      :userId="item.userId"
      :portrait="item.portrait"
      :timeStamp="item.timeStamp"
      :content="item.content"
      :msgId="item.msgId"
      :selected="isSelected(item)"
      @click.native="choose(item)"
    >
    </LeftListItem>
  </div>
</template>

<script>
import LeftListItem from '../LeftListItem'
import { isScrollToBottom, debounce } from '../../../../lib/utils'

export default {
  name: 'checkLetterList',
  props: ['list', 'curSelect'],
  data() {
    return {}
  },
  methods: {
    isSelected(item) {
      return this.curSelect.indexOf(item.msgId) > -1
    },
    choose(item) {
      this.$emit('select', item.msgId)
    },
    isReachBottom() {
      const listView = this.$refs.listView
      if (isScrollToBottom(listView)) {
        this.$emit('to-bottom')
      }
    }
  },
  mounted() {
    // 滚动函数防抖
    this.isReachBottom = debounce(this.isReachBottom, 100, false)
  },
  components: {
    LeftListItem
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
